import { createAction, props } from "@ngrx/store";
import { CalculationHeaderApi } from "src/app/types";

// Hourly Rates / Header lines
export const addHeaderLine = createAction(
    '[Calculation] Add Header Line',
    props<{ projectId: string, calculationId: string, rate: CalculationHeaderApi }>()
  );
  
  export const addHeaderLineSuccess = createAction(
    '[Calculation] Add Header Line Success',
    props<{ rate: CalculationHeaderApi }>()
  );
  
  export const addHeaderLineFailure = createAction(
    '[Calculation] Add Header Line Failure',
    props<{ error: any }>()
  );
  
  export const updateHeaderLine = createAction(
    '[Calculation] Update Header Line',
    props<{ projectId: string, calculationId: string, line: CalculationHeaderApi }>()
  )
  
  export const updateHeaderLineSuccess = createAction(
    '[Calculation] Update Header Line Success',
    props<{ line: CalculationHeaderApi }>()
  )
  
  export const updateHeaderLineFailure = createAction(
    '[Calculation] Update Header Line Failure',
    props<{ error: any }>()
  );
  
  export const deleteHeaderLine = createAction(
    '[Calculation] Delete Header Line',
    props<{ projectId: string, calculationId: string, rate: CalculationHeaderApi }>()
  );
  
  export const deleteHeaderLineSuccess = createAction(
    '[Calculation] Delete Header Line Success',
    props<{ rate: CalculationHeaderApi }>()
  );
  
  export const deleteHeaderLineFailure = createAction(
    '[Calculation] Delete Header Line Failure',
    props<{ error: any }>()
  );